module.exports = __webpack_public_path__ + "static/img/s_microderm.1e99c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/s_microderm.jpg
// module id = 101
// module chunks = 1